/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps, useJsonForms } from "@jsonforms/react";
import React, { useEffect, useState } from "react";
// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";
import {
  evaluateContextRule,
  extractPath,
  resolveContextValue,
} from "../utils/commonUtils";

/**
 * Default tester for a Rich text.
 * @type {RankedTester}
 */
export const spectrumRichTextRendererTester: RankedTester = rankWith(
  2,
  uiTypeIs("RichText")
);

/**
 * Default renderer for a Rich text.
 */
function SpectrumRichTextRenderer({ uischema, visible }: RendererProps) {
  let resolvedContent = uischema.options?.content;
  const defaultValue = uischema.options?.defaultValue;
  const reduxStateObj = useSelector((state: any) => state?.reduxState);
  const contextContent = resolveContextValue(reduxStateObj, resolvedContent);
  if (typeof contextContent !== "undefined") {
    resolvedContent = contextContent;
  }

  const [content, setContent] = useState(resolvedContent);

  useEffect(() => {
    // Sync the content if value changes
    if (content !== resolvedContent) {
      setContent(resolvedContent);
    }
  }, [resolvedContent]);

  const style = uischema.options?.style;
  const contentId = uischema.options?.contentId;
  const context = useJsonForms();
  const textCallback =
    context?.config?.lifecycleHooks?.onSuccessCallbacks?.richText;
  const onTextChange = textCallback?.onTextChange;

  if (onTextChange) {
    onTextChange({ content, setContent, contentId });
  }

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  const valueToRender = content === "" && defaultValue ? defaultValue : content;

  return valueToRender ? (
    <div
      dangerouslySetInnerHTML={{ __html: valueToRender }}
      style={{ ...style }}
      hidden={!componentVisibility}
    />
  ) : null;
}

export default withJsonFormsLayoutProps(SpectrumRichTextRenderer);
